export enum TpayVerificationStatus {
  NOT_REGISTERED = 'NOT_REGISTERED',
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  UNKNOWN = 'UNKNOWN',
}
